import React, {useEffect, useMemo, useRef, useState, useCallback} from 'react';
import styled from 'styled-components';
import {useParams, useSearchParams} from 'react-router-dom';
import {
    TopWrapperVideo,
    TopWrapperVideoContent,
    VideoContent,
    VideoPlayerWrapper,
    VideoWrapper
} from '../../style/VideoStyle';
import {VideoPlayer} from '../tournametns/player/ui/VideoPlayer';
import {FormWrapPopup, MainWrapper, TopWrapper} from '../../style/DasboardMain';
import Navigation from '../../components/Navigation/Navigation';
import IntroText from "../../components/introText/index";
import Button from '../../components/button';
import TextInput from '../../components/inputs/TextInput';
import Modal from "../../components/modal/index";
import {Dropdown, DropdownButton, DropdownContent, DropdownItem} from '../tournametns/player/ShotsPlayer';

import arrowIconUp from "../../images/up.svg";
import arrowIconDown from "../../images/down.svg";
import {$apiV1, VIDEO_SERVICE_URL} from '../../config/api';
import {VideoListPanel} from '../../components/playlist/VideoListPanel';
import {useLexicon} from '../../hooks/useLexicon';
import {useSelector} from 'react-redux';
import { trackPlaylistAction } from '../../tracking';

const Index = () => {
    const l = useLexicon();
    const {id} = useParams();
    const [searchParams] = useSearchParams();
    const recordRef = useRef(null);

    const [playlist, setPlaylist] = useState(null);
    const [videoHref, setVideoHref] = useState('');
    const [videoSecond, setVideoSecond] = useState(0);

    const [loadingVideo, setLoadingVideo] = useState(false);

    const [openAddVideo, setOpenAddVide] = useState(false);
    const [folderName, setFolderName] = useState("");

    const [userPlaylists, setUserPlaylists] = useState([]);
    const [selectedPlaylist, setSelectedPlaylist] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [loadingAddPlaylist, setLoadingAddPlaylist] = useState(false);

    const [record, setRecord] = useState(null);
    const [recordTime, setRecordTime] = useState(null);

    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [disabledNext, setDisabledNext] = useState(true);
    const [disabledPrev, setDisabledPrev] = useState(true);
    const [analystToggle, setAnalystToggle] = useState(false);
    const videoPlayerRef = useRef(null);
    const isCutLoadingRef = useRef(false);
    const currentStartRef = useRef(null);
    const currentEndRef = useRef(null);
    const cutAbortControllerRef = useRef(null);
    const {offset_range_begin = 10, offset_range_end = 10, merge_offset} = useSelector(state => state.user.userProfile);
    const [videoIndex, setVideoIndex] = useState(0);

    // "Show full sequence" state — mirrors the tournament video page. The chip
    // lives entirely inside VideoPlayer and only appears when the active event
    // carries a possession_sequence_id (see hasPossessionSequence there).
    const [showFullSequence, setShowFullSequence] = useState(false);
    const [sequenceNav, setSequenceNav] = useState({prevMarkerId: null, nextMarkerId: null});
    // Original single-event playlist item, kept so "Show event only" can restore
    // it even after stepping through adjacent sequences.
    const fullSequenceOriginRef = useRef(null);
    // Guards against a stale possession_sequence response overwriting a newer
    // playback the user has since started.
    const sequenceRequestIdRef = useRef(0);
    // Set while playSequenceForMarker drives handlePlayVideo, so the generic
    // reset below doesn't wipe the sequence state we just set.
    const isSequencePlaybackRef = useRef(false);

    useEffect(() => {
        console.log("HANDLE PLAY VIDEO GOT NEW OFFSETS:  ", offset_range_begin, offset_range_end, currentVideoIndex);
        if (playlist) {
            setRecord(playlist.videos?.[currentVideoIndex]);
            handlePlayVideo(playlist.videos?.[currentVideoIndex], currentVideoIndex, offset_range_begin, offset_range_end, 0, true);
            getPlaylist();


        }

    }, [offset_range_begin, offset_range_end]);

    const getPlaylist = async () => {
        const response = await $apiV1.get(`/users/playlists/${id}`);
        setPlaylist(response.data);
        trackPlaylistAction({
            action: 'open',
            entityId: response?.data?.id || Number(id),
            entityLabel: response?.data?.title || null,
            metadata: {
                videos_count: Array.isArray(response?.data?.videos) ? response.data.videos.length : 0,
            },
            sourceSurface: 'playlist',
        });
    }

    const AnalystToggleWrap = styled.div`
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
        margin-right: ${(props) => (props.$stacked ? '0px' : '0px')};
        gap: 12px;
    `;

    const ToggleSwitch = styled.label`
        position: relative;
        display: inline-block;
        width: 38px;
        height: 22px;
    `;

    const ToggleInput = styled.input`
        opacity: 0;
        width: 0;
        height: 0;
    `;

    const ToggleSlider = styled.span`
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${(props) => props.theme.blueish3};
        transition: 0.4s;
        border-radius: 34px;

        &:before {
            position: absolute;
            content: '';
            height: 20px;
            width: 20px;
            left: 1px;
            bottom: 1px;
            background-color: #fff;
            transition: 0.4s;
            border-radius: 50%;
        }

        ${ToggleInput}:checked + & {
            background-color: ${(props) => props.theme.green};
        }

        ${ToggleInput}:checked + &:before {
            transform: translateX(16px);
        }
    `;

    const AnalystOverlay = styled.div`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.7);
        opacity: ${(props) => (props.$visible ? 1 : 0)};
        pointer-events: ${(props) => (props.$visible ? 'auto' : 'none')};
        transition: opacity 0.3s ease-in-out;
        z-index: 1000;
    `;

    const FocusLayer = styled.div`
        position: relative;
        z-index: ${(props) => (props.$focus ? 1002 : 'auto')};
    `;


    const userState = useSelector(state => state.user.userProfile);

    useEffect(() => {
        const getUserPlaylists = async () => {
            try {
                const res = await $apiV1.get('/users/playlists');
                setUserPlaylists(res.data);
            } catch (e) {
                console.log('get user playlists err', e.message);
            }
        }

        getUserPlaylists();
    }, [])

    useEffect(() => {
        recordRef.current = record;
    }, [record]);

    useEffect(() => {
        const video_id = searchParams.get('video');

        const getPlaylist = async (id, video_id) => {
            try {
                const response = await $apiV1.get(`/users/playlists/${id}`);
                setPlaylist(response.data);
                if (video_id) {
                    const existVideoIndex = response.data?.videos?.findIndex(item => item.id === video_id);
                    if (existVideoIndex >= 0) {
                        setVideoIndex(existVideoIndex);
                        setRecord(response.data?.videos?.[existVideoIndex]);
                        handlePlayVideo(response.data?.videos?.[existVideoIndex], existVideoIndex);
                    }
                }
            } catch (e) {
                console.log('get playlist error', e.message);
                alert(`Get playlist error: ${e.message}`)
            }
        }
        id && getPlaylist(+id, Number(video_id));
    }, [searchParams, id, userState?.merge_offset])

    useEffect(() => {
        setDisabledPrev(currentVideoIndex === 0);
        setDisabledNext(currentVideoIndex >= playlist?.videos?.length - 1);
        // handlePlayVideo(videoSource);
    }, [currentVideoIndex, playlist]);

    const handleSelectChange = (value) => {
        setSelectedPlaylist(value);
    };

    const handleEmailChange = (newValue) => {
        setFolderName(newValue);
    };

    const addRecordToPlaylist = () => {
        setOpenAddVide(true);
    }

    const handlePrevVideo = () => {
        if (currentVideoIndex > 0) {
            setRecord(playlist?.videos?.[currentVideoIndex - 1]);
            handlePlayVideo(playlist?.videos?.[currentVideoIndex - 1]);
        }
    };

    const handleNextVideo = () => {
        if (currentVideoIndex < playlist?.videos?.length - 1) {
            setRecord(playlist?.videos?.[currentVideoIndex + 1]);
            handlePlayVideo(playlist?.videos?.[currentVideoIndex + 1]);
        }
    };

    const addNewFolder = async () => {
        try {
            setLoadingAddPlaylist(true);
            let playlist;

            if (!selectedPlaylist) {
                // First API request to create a new folder
                const createFolderResponse = await $apiV1.post(`/users/playlists`,
                    {title: folderName},
                );
                playlist = createFolderResponse.data;
                trackPlaylistAction({
                    action: 'create',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || folderName,
                    sourceSurface: 'playlist',
                });
                setUserPlaylists(prev => [playlist, ...prev])
            } else {
                playlist = selectedPlaylist;
            }

            setOpenAddVide(!openAddVideo);

            if (record?.id && recordTime?.startTime && recordTime?.endTime) {
                const params = {
                    end_second: +(+recordTime.endTime).toFixed(0),
                    start_second: +(+recordTime.startTime).toFixed(0),
                    event_id: record.id,
                    title: `Record from ${recordTime.startTime.toFixed(0)} to ${recordTime.endTime.toFixed(0)}`
                }
                // await getCutVideo(params);
                await $apiV1.post(`/users/playlists/${playlist.id}/add`,
                    [params],
                );
                trackPlaylistAction({
                    action: 'video_add',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || null,
                    metadata: {
                        clip_end_second: params.end_second,
                        clip_start_second: params.start_second,
                        event_id: record?.id,
                        playlist_id: playlist?.id,
                    },
                    sourceSurface: 'playlist',
                });
                return
            }
        } catch (error) {
            console.error("Error processing request:", error);
        } finally {
            setLoadingAddPlaylist(false);
        }
    };

    const handlePlayVideo = async (video, idx, overrideStart, overrideEnd, resume_second, fullOverride = false) => {
        try {
            console.log("HANDLE PLAY VIDEO  ", video);
            // Any fresh event selection (next/prev, list click, offsets reload)
            // exits full-sequence mode; the sequence path opts out via the ref.
            if (!isSequencePlaybackRef.current) {
                setShowFullSequence(false);
                setSequenceNav({prevMarkerId: null, nextMarkerId: null});
                fullSequenceOriginRef.current = null;
            }
            isSequencePlaybackRef.current = false;
            const video_idx = playlist?.videos?.findIndex(item => item.id === video.id);
            console.log("HANDLE PLAY VIDEO video_idx  ", video_idx);
            // Fix: use >= 0 check since findIndex returns -1 for not found, and 0 is valid
            setCurrentVideoIndex(video_idx >= 0 ? video_idx : (idx ?? 0));

            if (!video?.details?.video) {
                console.log("HANDLE PLAY VIDEO - No video.details.video found!", video);
                return;
            }

            // Cancel any pending cut request before starting a new one
            if (cutAbortControllerRef.current) {
                cutAbortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            cutAbortControllerRef.current = abortController;

            setLoadingVideo(true);
            isCutLoadingRef.current = true;
            setRecord(video);
            let start = video?.start_second;
            let end = video?.end_second;


            if (fullOverride) {
                // details.second is fractional, but the video service rejects a
                // fractional start/end (422), so cut on whole seconds.
                start = Math.round(+video.details.second - overrideStart);
                end = Math.round(+video.details.second + overrideEnd);

                currentStartRef.current = start;
                currentEndRef.current = end;
            } else {

                start = typeof overrideStart === 'number' ? overrideStart : video?.start_second;
                end = typeof overrideEnd === 'number' ? overrideEnd : video?.end_second;
                currentStartRef.current = start;
                currentEndRef.current = end;

            }

            console.log("HANDLE PLAY VIDEO start end  ", video.details.start_second, start, end);

            const url = `${VIDEO_SERVICE_URL}/cut`;
            const response = await fetch(url, {
                body: JSON.stringify({
                    path: decodeURI(video?.details?.video),
                    start,
                    end
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
                signal: abortController.signal,
            });
            const json = await response.json();
            console.log("HANDLE PLAY VIDEO API response  ", json);

            // Only update state if this request wasn't aborted
            if (!abortController.signal.aborted) {
                if (json.data && json.data.path) {
                    // Force state update even if same path by adding timestamp
                    const newPath = json.data.path;
                    setVideoHref(prev => {
                        // If same path, append cache-buster to force reload
                        if (prev === newPath) {
                            const separator = newPath.includes('?') ? '&' : '?';
                            return `${newPath}${separator}_t=${Date.now()}`;
                        }
                        return newPath;
                    });
                    if (typeof resume_second === 'number') {
                        setVideoSecond(resume_second);
                    } else {
                        setVideoSecond(0);
                    }
                } else {
                    console.log("HANDLE PLAY VIDEO - No path in response!", json);
                }

                if (json.errors && json.errors.length) {
                    alert(`Errors: ${json.errors.join(" , ")}`)
                }
            } else {
                console.log("HANDLE PLAY VIDEO - Request was aborted");
            }
        } catch (e) {
            // Ignore abort errors - they're expected when clicking a new video
            if (e.name === 'AbortError') {
                console.log('Cut request aborted - new video selected');
                return;
            }
            alert(`Get video error, ${e.message}`);
            console.log('get cut video err', e.message);
        } finally {
            setLoadingVideo(false);
            isCutLoadingRef.current = false;
        }
    };

    const toExtend = (edge, overflowSeconds = 0) => {
        handleExtendVideo(edge, overflowSeconds, recordRef.current);
    }

    const handleExtendVideo = useCallback(async (edge, overflowSeconds = 0, video = null) => {
        try {
            console.log("START HANDLE EXTEND VIDEO   ", edge, overflowSeconds, video);
            const extend = Math.max(overflowSeconds, 1);
            // pause to avoid auto-next during recut
            videoPlayerRef.current?.pause();

            if (edge === 'end') {
                const baseEnd = typeof currentEndRef.current === 'number' ? currentEndRef.current : (video?.end_second ?? 0);
                const newEnd = baseEnd + extend;
                const currentInCutPlayback = typeof videoPlayerRef.current?.getCurrentTime === 'function' ? (videoPlayerRef.current.getCurrentTime() ?? 0) : 0;
                currentEndRef.current = newEnd;
                if (video) {
                    await handlePlayVideo(video, null, currentStartRef.current ?? video?.start_second, newEnd, currentInCutPlayback);
                }
            } else if (edge === 'start') {
                const baseStart = typeof currentStartRef.current === 'number' ? currentStartRef.current : (video?.start_second ?? 0);
                const newStart = Math.max(0, baseStart - extend);
                const currentInCutPlayback = typeof videoPlayerRef.current?.getCurrentTime === 'function' ? (videoPlayerRef.current.getCurrentTime() ?? 0) : 0;
                currentStartRef.current = newStart;
                console.log("START HANDLE EXTEND VIDEO 2 START");
                console.log("VIDEO", video);
                console.log("CURRENT START REF", currentStartRef.current);
                console.log("CURRENT END REF", currentEndRef.current);
                console.log("NEW START", newStart);
                console.log("CURRENT IN CUT PLAYBACK", currentInCutPlayback);
                if (video) {
                    await handlePlayVideo(video, null, newStart, currentEndRef.current ?? video?.end_second, currentInCutPlayback);
                }
            }
        } catch (e) {
            console.log('extend video error', e);
        }
    }, [handlePlayVideo]);

    // Resolve the possession sequence a marker belongs to and replay the active
    // playlist clip spanning the whole sequence (±standard offsets). Shared by
    // "Show full sequence" and the prev/next sequence navigation. `base` is the
    // playlist item that supplies the video/marker context. Returns true when a
    // sequence was found and playback started.
    const playSequenceForMarker = async (markerId, base) => {
        if (!markerId || !base?.details?.video) return false;
        videoPlayerRef.current?.pause();

        const requestId = ++sequenceRequestIdRef.current;
        const response = await $apiV1.get(`/stats/markers/${markerId}/possession_sequence`);
        // A newer playback started while we were resolving — drop this result.
        if (requestId !== sequenceRequestIdRef.current) return false;

        const data = response?.data || {};
        const startSecond = Number(data.start_second);
        const lastSecond = Number(data.last_second ?? data.end_second);

        if (!Number.isFinite(startSecond) || !Number.isFinite(lastSecond)) {
            alert('No sequence found for this event.');
            return false;
        }

        // Play the merged span via the absolute-range (non-fullOverride) path.
        isSequencePlaybackRef.current = true;
        await handlePlayVideo(
            base,
            null,
            startSecond - offset_range_begin,
            lastSecond + offset_range_end,
            0,
            false
        );
        setSequenceNav({
            prevMarkerId: data.prev_marker_id ?? null,
            nextMarkerId: data.next_marker_id ?? null,
        });
        setShowFullSequence(true);
        return true;
    };

    const handleShowFullSequence = async (event) => {
        const marker = event || record;
        // details.id is the video id; the possession_sequence endpoint keys off
        // the marker id, which the playlist resource exposes as event_id.
        const markerId = marker?.details?.event_id;
        if (!markerId) return;
        try {
            // Keep the original single-event item so "Show event only" can
            // restore it even after navigating to adjacent sequences.
            fullSequenceOriginRef.current = marker;
            await playSequenceForMarker(markerId, marker);
        } catch (e) {
            if (e.name === 'AbortError') return;
            console.log('show full sequence error', e);
            alert(`Show full sequence error, ${e.message}`);
        }
    };

    // Step to the possession sequence immediately before/after the one shown.
    // The base stays the original event (same match); the origin ref is left
    // untouched so "Show event only" still returns to where the user started.
    const handleShowAdjacentSequence = async (direction) => {
        const targetMarkerId = direction === 'next'
            ? sequenceNav.nextMarkerId
            : sequenceNav.prevMarkerId;
        if (!targetMarkerId) return;
        const base = fullSequenceOriginRef.current || record;
        try {
            await playSequenceForMarker(targetMarkerId, base);
        } catch (e) {
            if (e.name === 'AbortError') return;
            console.log('show adjacent sequence error', e);
            alert(`Show ${direction} sequence error, ${e.message}`);
        }
    };

    // Inverse of handleShowFullSequence: replay just the single event the
    // sequence was expanded from.
    const handleShowEventOnly = async (event) => {
        const origin = fullSequenceOriginRef.current || event || record;
        if (!origin?.details?.video) return;
        try {
            await handlePlayVideo(origin, null, offset_range_begin, offset_range_end, 0, true);
            setShowFullSequence(false);
            setSequenceNav({prevMarkerId: null, nextMarkerId: null});
            fullSequenceOriginRef.current = null;
        } catch (e) {
            console.log('show event only error', e);
            alert(`Show event only error, ${e.message}`);
        }
    };

    const modal = (
        <Modal isOpen={openAddVideo} setIsOpen={setOpenAddVide} closeIc>
            <h1>
                {l(1027)}
            </h1>
            <FormWrapPopup style={{marginTop: "20px"}}>
                <Dropdown>
                    <DropdownButton
                        onClick={() => setShowDropdown(!showDropdown)}
                    >
                        {!selectedPlaylist
                            ? `${l(1088)}`
                            : `${selectedPlaylist?.title}`}
                        <img src={showDropdown ? arrowIconUp : arrowIconDown}/>
                    </DropdownButton>
                    <DropdownContent $show={showDropdown}>
                        {userPlaylists.map((item) => (
                            <DropdownItem
                                key={item.id}
                                selected={item.id === selectedPlaylist?.id}
                                onClick={() => handleSelectChange(item)}
                            >
                                {item.title}
                            </DropdownItem>
                        ))}
                    </DropdownContent>
                </Dropdown>
                <TextInput
                    label={l(1089)}
                    type={"text"}
                    value={folderName}
                    placeholder={l(1090)}
                    onChange={handleEmailChange}
                />
            </FormWrapPopup>
            <Button
                style={{zIndex: 1}}
                title={l(426)}
                size={"full"}
                onClick={() => addNewFolder()}
                disabled={loadingAddPlaylist}
            />
        </Modal>
    );

    return (
        <MainWrapper>
            <Navigation/>

            <VideoWrapper
                className={
                    localStorage.getItem("navigationOpen") === "true"
                        ? ""
                        : "fullWidthPage"
                }
            >
                <TopWrapper>
                    <FocusLayer $focus={analystToggle}>
                        <IntroText title={`${l(124)} ${playlist?.title}`}/>
                    </FocusLayer>
                </TopWrapper>
                <AnalystOverlay $visible={analystToggle}/>
                <VideoPlayerWrapper $stacked={analystToggle}>
                    <VideoListPanel
                        stacked={analystToggle}
                        handlePlayVideo={handlePlayVideo}
                        currentVideoIndex={currentVideoIndex}
                        playlist={playlist}
                    />

                    <VideoContent $focus={analystToggle} $stacked={analystToggle} $playlist={true}>
                        <AnalystToggleWrap className="analyst-toggle-container" $stacked={analystToggle}
                                           style={{position: 'absolute', top: '-30px', right: '2px'}}>
                            <div className="analyst-toggle-text"
                                 style={{color: 'white', fontSize: '16px', fontFamily: 'SatoshiBold'}}>
                                {l(1113)}
                            </div>
                            <ToggleSwitch>
                                <ToggleInput
                                    type="checkbox"
                                    checked={analystToggle}
                                    onChange={(e) => {
                                        const next = e.target.checked;
                                        setAnalystToggle(next);
                                        localStorage.setItem("navigationOpen", next ? false : true);
                                        window.dispatchEvent(new Event("navigationOpenChange"));
                                    }}
                                />
                                <ToggleSlider/>
                            </ToggleSwitch>
                        </AnalystToggleWrap>
                        <VideoPlayer
                            ref={videoPlayerRef}
                            video={videoHref}
                            toSecond={videoSecond}
                            playNextVideo={handleNextVideo}
                            playPrevVideo={handlePrevVideo}
                            videos={playlist?.videos || []}
                            loading={loadingVideo}
                            record={record}
                            setRecord={setRecord}
                            recordTime={recordTime}
                            setRecordTime={setRecordTime}
                            addRecordToPlaylist={addRecordToPlaylist}
                            disabledNext={disabledNext}
                            disabledPrev={disabledPrev}
                            onExtendVideo={toExtend}
                            isLoadingRef={isCutLoadingRef}
                            onShowFullSequence={handleShowFullSequence}
                            onShowEventOnly={handleShowEventOnly}
                            onShowPreviousSequence={() => handleShowAdjacentSequence('prev')}
                            onShowNextSequence={() => handleShowAdjacentSequence('next')}
                            hasPreviousSequence={!!sequenceNav.prevMarkerId}
                            hasNextSequence={!!sequenceNav.nextMarkerId}
                            isFullSequenceActive={showFullSequence}
                        />
                    </VideoContent>
                </VideoPlayerWrapper>
            </VideoWrapper>
            {modal}
        </MainWrapper>
    );
}

export default Index;
